<div id="iframe-portalV1">
    <div class="container-fluid">
        <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
            <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
                <ol class="breadcrumb ol-sf-1">
                    <li class="breadcrumb-item">
                        <a *ngIf="loggedInUser?.permissions.isMckayUser"
                           routerLink="/mckay/{{loggedInUser?.company.uniqid}}">Home</a>
                        <a *ngIf="!loggedInUser?.permissions.isMckayUser"
                           routerLink="/client/{{loggedInUser?.company.uniqid}}">Home</a></li>
                    <li class="breadcrumb-item">
                        <a routerLink="/schedules">List Schedules</a>
                    </li>
                    <li aria-current="page" class="breadcrumb-item active">
                        {{ currentSchedule?.name }}
                    </li>
                    <li aria-current="page" class="breadcrumb-item active">
                        {{ currentEtree?.name }}
                    </li>
                </ol>
            </nav>
        </nav>
    </div>
    <div *ngIf="currentEtree && currentSchedule" class="layout-main">
        <div class="container-fluid">
            <div *ngIf="currentEtree" class="pb-2 mb-3 border-bottom">
                <div class="row" style="margin: 0">
                    <div class="col-8 p-fluid">
                        <h3>E-tree  {{ currentEtree.name }} overview</h3>
                        &nbsp;&nbsp;<a *roles="['ROLE_MCKAY']" [href]="bwmEtreeUrl + currentEtree.id" target="_blank"><i
                            aria-hidden="true" class="fa fa-external-link" style="color: #eb9316">edit in BWM
                    </i></a>
                        &nbsp;&nbsp;
                        <button (click)="gotoAnnoucementPage()" *ngIf="currentEtree.onGoingAnnouncement && currentEtree.onGoingOutage"
                                icon="fa fa-exclamation-triangle" pButton [class]="getClassForCategory(currentEtree.announcementCategory)"
                                title="Outage" type="button"></button>
                        <button (click)="gotoAnnoucementPage()" *ngIf="currentEtree.onGoingAnnouncement && !currentEtree.onGoingOutage"
                                icon="fa fa-exclamation-triangle" pButton [class]="getClassForCategory(currentEtree.announcementCategory)"
                                [title]="getLabelFromAnnouncementCategory(currentEtree.announcementCategory)" type="button"></button>
                    </div>
                    <div class="col-4 p-fluid ">
                        <button [disabled]="!currentEtree.vvlanId"
                                [pTooltip]="currentEtree.vvlanId ? null : 'No Graph data to be displayed'"
                                [routerLink]="'/bandwidth-graphs/etree/' + currentEtree.vvlanId"
                                class="btn btn-outline-primary button-size float-right mr-2"
                                tooltipPosition="bottom">
                            <i aria-hidden="true" class="fa fa-line-chart pr-1"></i>
                            View end-to-end graph
                        </button>
                        <button (click)="exportEtreeJsonData()"
                                class="btn btn-outline-primary button-size float-right mr-2"
                                type="reset">
                            <i aria-hidden="true" class="fa fa-download pr-2"></i>
                            Export as json
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="displayJiraFeature">
                    <div class="row justify-content-end mr-4 mb-1">
                        <button (click)="openSendJiraPopup()"
                                class="btn btn-link no-padding-button ng-star-inserted jira-button"
                                type="button">
                            <i class="fa fa-ticket"></i> Open JIRA trouble ticket
                        </button>
                    </div>
                </ng-container>
                <div *ngIf="successCreateJira" class="alert alert-success alert-dismissible fade show">
                    Jira ticket number.{{ jiraIssueCode }}  created:
                    <a href="{{ jiraLink }}" target="_blank"> jira link </a>
                    <button (click)="successCreateJira = false" aria-label="Close" class="close" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div *ngIf="jiraCreationError" class="alert alert-danger alert-dismissible fade show">
                    A JIRA ticket could not be created. You may leave this page open and retry later. We are informing
                    the
                    support.
                    <button (click)="jiraCreationError = false" aria-label="Close" class="close" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="p-grid p-fluid">
                    <div *ngIf="currentEtree.lastBwmUpdatedDate && currentEtree.lastBwmUpdatedDate!=''"
                         class=" col-12 col-md-12">
                        <p class="alert alert-info">
                            The E-Tree data on this page are updated daily. This page was last updated
                            on {{ lastUpdatedAt | date : "MMM dd, y H:mm" }}. There may be some time lag (< 24h) between
                            the
                            processing
                            of your
                            latest change request and this display.<br>
                        </p>
                    </div>
                    <div class=" col-12 col-md-6">
                        <div class="p-grid p-fluid">
                            <div class="col-12">
                                <p-fieldset [collapsed]="false" [toggleable]="true">
                                    <ng-template pTemplate="header">E-Tree summary</ng-template>
                                    <ul>
                                        <li>Name: {{ currentEtree.name }}</li>
                                        <li>E-Tree ID: {{ currentEtree.contractReference }}</li>
                                        <li>Client Reference: {{ currentEtree.clientReference }}</li>
                                        <ng-container *ngIf="currentEtree.activeEtreeInjectionDemarcationPoint">
                                            <li *ngIf="currentEtree.injectionPoint && !currentEtree.injectionPoint.pop">
                                                Injection cross
                                                connect(s) / Bandwidth (Injection pop):
                                                <p-table [autoLayout]="true" [responsive]="true"
                                                         class="mt-1 mb-1"
                                                         [value]="currentEtree.activeEtreeInjectionDemarcationPoint['activeClientConnectionPoints']">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Injection Method</th>
                                                            <th>Injection pop</th>
                                                            <th>Injection Cross Connect</th>
                                                            <th>Clien Vlan</th>
                                                            <th>Header Key</th>
                                                            <th>Tagged Frame</th>
                                                            <th>Bandwidth</th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template let-ccp let-rowIndex="rowIndex" pTemplate="body">
                                                        <tr>
                                                            <td>{{ ccp['mbelAllocation'] }}</td>
                                                            <td>{{ ccp['popNameForInjectList'] }}</td>
                                                            <td>{{ ccp['crossConnectId'] }}</td>
                                                            <td>{{ ccp['clientVlan'] }}</td>
                                                            <td>{{ ccp['mbelHeaderKey'] }}</td>
                                                            <td><i class="fa"
                                                                   [ngClass]="ccp['taggedFrames'] ? 'fa-check text-green-500' : 'fa-times text-red-500'"></i>
                                                            </td>
                                                            <td> {{ ccp['bwAllocation'] }} Mbps</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                        </ng-container>
                                        <!--                                        <ng-container-->
                                        <!--                                                *ngIf="currentEtree && currentEtree.injectionPoint && !currentEtree.injectionPoint['injectionList']">-->

                                        <!--                                            <li *ngIf="currentEtree.injectionPoint && !currentEtree.injectionPoint.pop">-->
                                        <!--                                                Injection cross-->
                                        <!--                                                connect(s) / Bandwidth (Injection pop):-->
                                        <!--                                                <ul>-->
                                        <!--                                                    <li *ngFor="let xco of currentEtree.injectionPoint['ccps']['xcos'] | keyvalue">-->
                                        <!--                                                        {{ xco.key }}: {{ xco.value }}-->
                                        <!--                                                        - {{ currentEtree.injectionPoint['ccps']['bandwidth'][xco.key] }}-->
                                        <!--                                                        Mbps ({{ currentEtree.injectionPoint['ccps']['pops'][xco.key] }}-->
                                        <!--                                                        )-->
                                        <!--                                                    </li>-->
                                        <!--                                                </ul>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li *ngIf="currentEtree.injectionPoint && currentEtree.injectionPoint.pop">-->
                                        <!--                                                Injection cross-->
                                        <!--                                                connect(s) / Bandwidth:-->
                                        <!--                                                <ul>-->
                                        <!--                                                    <li *ngFor="let xco of currentEtree.injectionPoint['ccps']['xcos'] | keyvalue">-->
                                        <!--                                                        {{ xco.key }}: {{ xco.value }}-->
                                        <!--                                                        - {{ currentEtree.injectionPoint['ccps']['bandwidth'][xco.key] }}-->
                                        <!--                                                        Mbps-->
                                        <!--                                                    </li>-->
                                        <!--                                                </ul>-->
                                        <!--                                            </li>-->
                                        <!--                                            <li *ngIf="currentEtree.injectionPoint.pop">Injection-->
                                        <!--                                                pop: {{ currentEtree.injectionPoint.pop }}-->
                                        <!--                                            </li>-->
                                        <!--                                        </ng-container>-->
                                        <!--                                        <ng-container-->
                                        <!--                                                *ngIf="currentEtree && currentEtree.injectionPoint && currentEtree.injectionPoint['injectionList']">-->
                                        <!--                                            {{currentEtree.injectionPoint['injectionList']|json}}-->
                                        <!--                                        </ng-container>-->
                                        <li *ngIf="loggedInUser?.permissions.isMckayUser && currentEtree.serviceTypeShort">Service Type Short: {{ currentEtree.serviceTypeShort }}</li>
                                        <li>E-tree Uuid: {{ currentEtree.id }}</li>
                                        <li *ngIf="currentEtree.mbelMagicMac">Mbel Magic Mac:
                                            <ul>
                                                <li>Magic dest mac: {{ currentEtree.mbelMagicMac.magic_dest_mac }}</li>
                                                <li>Magic src mac: {{ currentEtree.mbelMagicMac.magic_src_mac }}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </p-fieldset>
                            </div>
                            <div *ngIf="loggedInUser?.permissions.isMckayUser && currentEtree.marsCircuits && currentEtree.marsCircuits.length>0"
                                 class="col-12">
                                <p-fieldset [collapsed]="false" [toggleable]="true">
                                    <ng-template pTemplate="header">E-Tree mars circuits</ng-template>
                                    <div class=" col-12">
                                        <p-table [autoLayout]="true" [responsive]="true"
                                                 [value]="currentEtree.marsCircuits">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Injection pop</th>
                                                    <th>Injection Cross Connect</th>
                                                    <th>reception pop(s)</th>
                                                    <th>Vlan</th>
                                                    <th>Bandwidth</th>
                                                </tr>
                                            </ng-template>
                                            <ng-template let-circuit let-rowIndex="rowIndex" pTemplate="body">
                                                <tr>
                                                    <td><a href="{{marsUrl}}{{circuit.uuid}}"
                                                           target="_blank"> {{ circuit.name }}</a></td>
                                                    <td>{{ circuit.injectionPop }}</td>
                                                    <td>{{ circuit.crossConnectId }}</td>
                                                    <td>{{ circuit.marsReceptionPoints.join(',') }}</td>
                                                    <td>{{ circuit.vlan }}</td>
                                                    <td>{{ circuit.bandwidth }}</td>
                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </p-fieldset>
                            </div>
                            <div *ngIf="currentEtree.spsEligible && (showInjection('LCM') || showLCMReception())"
                                 class="col-12">
                                <p-fieldset [collapsed]="false" [toggleable]="true">
                                    <ng-template pTemplate="header">E-tree LCM</ng-template>
                                    <h5 *ngIf="showInjection('LCM')">Injection</h5>
                                    <ng-container *ngIf="currentEtree.activeEtreeInjectionDemarcationPoint">
                                        <ng-container
                                                *ngFor="let ccp of currentEtree['activeEtreeInjectionDemarcationPoint']['activeClientConnectionPoints'] | keyvalue">
                                            <ng-container *ngIf="ccp.value['mbelAllocation']==='LCM'">
                                                <ul>
                                                    <li>Injection cross connect: {{ ccp.value['crossConnectId'] }}</li>
                                                    <ng-container
                                                            *ngIf="ccp.value['taggedFrames']; else nonTaggedFramesLcmInjection">
                                                        <li>Injection
                                                            mode: Tagged Frames
                                                        </li>
                                                        <li>VLAN: {{ ccp.value['clientVlan'] }}</li>
                                                    </ng-container>
                                                    <ng-template #nonTaggedFramesLcmInjection>
                                                        <li>Injection mode: Non Tagged Frames</li>
                                                    </ng-template>
                                                    <li>Injection Bandwidth: {{ ccp.value['bwAllocation'] }}</li>
                                                </ul>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <h5 *ngIf="showLCMReception()">Reception</h5>
                                    <ng-container *ngIf="currentEtree.etreeReceptionDemarcationPoints">
                                        <ng-container *ngFor="let rdp of currentEtree.etreeReceptionDemarcationPoints">
                                            <ng-container *ngIf="rdp['status'] !=='deprovisioned'">
                                                <ng-container
                                                        *ngFor="let ccp of rdp['activeClientConnectionPoints'] | keyvalue">
                                                    <ng-container
                                                            *ngIf="ccp.value['mbelAllocation']==='LCM' && ccp.value['relatedInjectionCcp']['mbelAllocation'] !=='MBEL'">
                                                        <ul>
                                                            <li *ngIf="rdp['popShortName']!== ccp.value['popTechnicalId']">
                                                                Reception
                                                                Pop:{{ rdp['popShortName'] }}
                                                                /{{ ccp.value['popTechnicalId'] }}
                                                            </li>

                                                            <li *ngIf="rdp['popShortName']=== ccp.value['popTechnicalId']">
                                                                Reception
                                                                Pop:{{ rdp['popShortName'] }}
                                                            </li>
                                                            <li>Reception cross
                                                                connect: {{ ccp.value['crossConnectId'] }}
                                                            </li>
                                                            <ng-container
                                                                    *ngIf="ccp.value['taggedFrames']; else nonTaggedFramesLcm">
                                                                <li>
                                                                    Reception Pop mode: Tagged Frames
                                                                </li>
                                                                <li>VLAN: {{ ccp.value['clientVlan'] }}</li>
                                                            </ng-container>
                                                            <ng-template #nonTaggedFramesLcm>
                                                                <li>Reception Pop mode: Non Tagged Frames</li>
                                                            </ng-template>
                                                        </ul>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </p-fieldset>
                            </div>
                            <div *ngIf="currentEtree.isMbelEligible && (showMBELReception() || showInjection('MBEL'))"
                                 class="col-12">
                                <p-fieldset [collapsed]="false" [toggleable]="true">
                                    <ng-template pTemplate="header">E-tree MBEL</ng-template>
                                    <h4>MBEL</h4>
                                    <h5 *ngIf="showInjection('MBEL')">Injection</h5>
                                    <ng-container *ngIf="currentEtree.activeEtreeInjectionDemarcationPoint">
                                        <ng-container
                                                *ngFor="let ccp of currentEtree['activeEtreeInjectionDemarcationPoint']['activeClientConnectionPoints'] | keyvalue">
                                            <ng-container *ngIf="ccp.value['mbelAllocation']==='MBEL'">
                                                <ul>
                                                    <li>Injection cross connect: {{ ccp.value['crossConnectId'] }}</li>
                                                    <li>MBEL header key: {{ ccp.value['mbelHeaderKey'] }}</li>
                                                    <ng-container
                                                            *ngIf="ccp.value['taggedFrames']; else nonTaggedFramesMbel">
                                                        <li>Injection
                                                            mode: Tagged Frames
                                                        </li>
                                                        <li *ngIf="ccp.clientVlan">
                                                            VLAN: {{ ccp.value['clientVlan'] }}</li>
                                                    </ng-container>
                                                    <ng-template #nonTaggedFramesMbel>
                                                        <li>Injection mode: Non Tagged Frames</li>
                                                    </ng-template>
                                                    <li>Injection Bandwidth: {{ ccp.value['bwAllocation'] }}</li>
                                                </ul>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                    <h5 *ngIf="showMBELReception()">Reception</h5>
                                    <ng-container *ngIf="currentEtree.etreeReceptionDemarcationPoints">
                                        <ng-container
                                                *ngFor="let rdp of currentEtree.etreeReceptionDemarcationPoints">
                                            <ng-container *ngIf="rdp['status'] !=='deprovisioned'">
                                                <ng-container
                                                        *ngFor="let ccp of rdp['activeClientConnectionPoints'] | keyvalue">
                                                    <ng-container
                                                            *ngIf="ccp.value['mbelAllocation']==='MBEL' || ccp.value['relatedInjectionCcp']['mbelAllocation']==='MBEL'">
                                                        <ul>
                                                            <li *ngIf="rdp['popShortName']!== ccp.value['popTechnicalId']">
                                                                Reception
                                                                Pop:{{ rdp['popShortName'] }}
                                                                /{{ ccp.value['popTechnicalId'] }}
                                                            </li>

                                                            <li *ngIf="rdp['popShortName'] === ccp.value['popTechnicalId']">
                                                                Reception
                                                                Pop:{{ rdp['popShortName'] }}
                                                            </li>
                                                            <li>Reception cross
                                                                connect: {{ ccp.value['crossConnectId'] }} <ng-container><b>{{getCcpAd(ccp.value)}}</b></ng-container>
                                                            </li>
                                                            <ng-container
                                                                    *ngIf="ccp.value['taggedFrames']; else nonTaggedFrames">
                                                                <li> Reception mode: Tagged Frames</li>
                                                                <li *ngIf="ccp.value['clientVlan']">Injection
                                                                    VLAN: {{ ccp.value['clientVlan'] }}</li>
                                                            </ng-container>
                                                            <ng-template #nonTaggedFrames>
                                                                <li>Reception mode: Non Tagged Frames</li>
                                                            </ng-template>
                                                        </ul>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </p-fieldset>
                            </div>
                            <div *ngFor="let method of etreeMethods" class="col-12">
                                <ng-container *ngIf="!currentEtree.spsEligible && !currentEtree.isMbelEligible">
                                    <p-fieldset [collapsed]="false" [toggleable]="true">
                                        <ng-template pTemplate="header">E-tree {{ method }}</ng-template>
                                        <h5 *ngIf="showInjection(method)">Injection</h5>
                                        <ng-container
                                                *ngFor="let ccp of currentEtree?.activeEtreeInjectionDemarcationPoint?.activeClientConnectionPoints">
                                            <ng-container *ngIf="ccp.mbelAllocation === method">
                                                <ul>
                                                    <li>Injection cross connect: {{ ccp.crossConnectId }}</li>
                                                    <ng-container
                                                            *ngIf="ccp.taggedFrames; else nonTaggedFramesLcmInjection">
                                                        <li>Injection mode: Tagged Frames
                                                        </li>
                                                        <li *ngIf="ccp.clientVlan">VLAN: {{ ccp.clientVlan }}</li>
                                                    </ng-container>
                                                    <ng-template #nonTaggedFramesLcmInjection>
                                                        <li>Injection mode: Non Tagged Frames</li>
                                                    </ng-template>
                                                    <li>Injection Bandwidth: {{ ccp.bwAllocation }} Mbps</li>
                                                </ul>
                                            </ng-container>
                                        </ng-container>
                                        <h5 *ngIf="showReception(method)">Reception</h5>
                                        <ng-container *ngFor="let rdp of currentEtree.etreeReceptionDemarcationPoints">
                                            <ng-container *ngIf="rdp.status !== 'deprovisioned'">
                                                <ng-container *ngFor="let ccp of rdp.activeClientConnectionPoints">
                                                    <ul *ngIf="ccp.mbelAllocation === method">
                                                        <li *ngIf="rdp.popShortName === ccp.popTechnicalId">
                                                            Reception Pop: {{ rdp.popShortName }}
                                                        </li>
                                                        <li *ngIf="rdp.popShortName !== ccp.popTechnicalId">
                                                            Reception
                                                            Pop:{{ rdp.popShortName }}/{{ ccp.popTechnicalId }}
                                                        </li>
                                                        <li>Reception cross connect: {{ ccp.crossConnectId }}<ng-container><b>{{getCcpAd(ccp)}}</b></ng-container></li>
                                                        <ng-container *ngIf="ccp.taggedFrames; else nonTaggedFramesLcm">
                                                            <li>
                                                                Reception Pop mode: Tagged Frames
                                                            </li>
                                                            <li *ngIf="ccp.clientVlan">VLAN: {{ ccp.clientVlan }}</li>
                                                        </ng-container>
                                                        <ng-template #nonTaggedFramesLcm>
                                                            <li>Reception Pop mode: Non Tagged Frames</li>
                                                        </ng-template>
                                                        <li *ngIf="ccp.bwAllocation">Bandwidth: {{ ccp.bwAllocation }}
                                                            Mbps
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </p-fieldset>
                                </ng-container>
                            </div>
                            <ng-container
                                    *ngIf="macAdressesKeys.length > 0">
                                <ng-container *ngFor="let injectionMethod of macAdressesKeys">
                                    <div *ngIf="(currentEtree.macAdresses[injectionMethod] && currentEtree.macAdresses[injectionMethod].length > 0) || (injectionMethod === 'LCM' && currentEtree.priorities && currentEtree.priorities.length > 0)"
                                         class=" col-12">
                                        <p-fieldset [collapsed]="false" [toggleable]="true">
                                            <ng-template *ngIf="injectionMethod==='LCM'" pTemplate="header">
                                                <ng-container *ngIf="currentEtree.macAdresses[injectionMethod] && currentEtree.macAdresses[injectionMethod].length > 0; else lcmNoMac">Live SPS MAC list: LCM to LCM</ng-container>
                                                <ng-template #lcmNoMac>Live SPS: LCM to LCM</ng-template>
                                            </ng-template>
                                            <ng-template *ngIf="injectionMethod==='MBEL'" pTemplate="header">Live SPS
                                                MAC list: MBEL to LCM
                                            </ng-template>
                                            <ng-template *ngIf="injectionMethod==='Metro-Prime-BW'" pTemplate="header">
                                                Live IEEE MAC list
                                            </ng-template>
                                            <ng-template
                                                    *ngIf="injectionMethod!=='LCM' &&injectionMethod!=='MBEL'  && injectionMethod!=='Metro-Prime-BW'"
                                                    pTemplate="header">
                                                Live {{ injectionMethod }} MAC list
                                            </ng-template>
                                            <ul>
                                                <li *ngIf="injectionMethod==='LCM'">
                                                    Sps: {{ currentEtree.spsEligible | questionableBoolean }}
                                                </li>
                                                <ng-container *ngIf="currentEtree.priorities">
                                                    <ng-container *ngFor="let priority of currentEtree.priorities">
                                                        <li *ngIf="priority['global_priority']==='4'">
                                                            High Priority Buffer: {{ priority['queue_size'] }}
                                                        </li>
                                                        <li *ngIf="priority['global_priority']==='2'">
                                                            Low Priority Buffer: {{ priority['queue_size'] }}
                                                        </li>
                                                    </ng-container>
                                                </ng-container>
                                                <li
                                                        *ngIf="currentEtree.macAdresses[injectionMethod] && currentEtree.macAdresses[injectionMethod].length > 0">
                                                    <ng-container *ngIf="injectionMethod!=='Metro-Prime-BW'">
                                                        <div class="p-grid p-fluid">
                                                            <div class=" col-12">
                                                                Sps Mac Entries:
                                                            </div>
                                                            <div class=" col-12">
                                                                <p-table
                                                                        [value]="currentEtree.macAdresses[injectionMethod]">
                                                                    <ng-template pTemplate="header">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>source</th>
                                                                            <th>destination</th>
                                                                        </tr>
                                                                    </ng-template>

                                                                    <ng-template let-row let-rowIndex="rowIndex"
                                                                                 pTemplate="body">
                                                                        <tr>
                                                                            <td>{{ rowIndex + 1 }}</td>
                                                                            <td>{{ row['source'] }}</td>
                                                                            <td>{{ row['destination'] }}</td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </div>
                                                        </div>
                                                        <div class="p-grid p-fluid">
                                                            <button (click)="downloadSpsMacAddressCsvFile(injectionMethod)"
                                                                    class="p-button-success pull-right"
                                                                    icon="fa fa-download"
                                                                    label="Download SPS & MAC list"
                                                                    pButton
                                                                    style="width: 33%"
                                                                    type="submit"></button>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="injectionMethod==='Metro-Prime-BW'">
                                                        <div class="p-grid p-fluid">
                                                            <div class=" col-12">
                                                                IEEE Macs :
                                                            </div>
                                                            <div *ngFor="let mac of currentEtree.macAdresses[injectionMethod]"
                                                                 class=" col-3">
                                                                {{ mac }}
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </li>
                                            </ul>
                                        </p-fieldset>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <div class=" col-12 col-md-6">
                        <div class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true" legend="Update client reference">
                                <!--                <ng-template pTemplate="header">Update client reference</ng-template>-->
                                <form [formGroup]="clientReferenceform">
                                    <div class="col-12 p-fluid">
                                        <p style="color: gray">Update client reference that will be displayed on
                                            invoices.</p>
                                    </div>
                                    <div class="col-12 p-fluid">
                                        <div [ngClass]="{'has-error': showClientreferenceErrorMessage('clientReference')}"
                                             class="form-group col-12 display-flex">
                                            <label class="col-form-label col-md-3" for="clientReference">
                                                Your reference :
                                            </label>
                                            <div class="pull-left col-form-input p-inputgroup">
                                                <input formControlName="clientReference" id="clientReference" pInputText
                                                       pInputText
                                                       size="15"
                                                       type="text">
                                            </div>
                                            <div class="col-12 col-md-6 col-lg-5">
                                                <button (click)="saveClientReference()"
                                                        [disabled]="!clientReferenceform.valid"
                                                        class="p-button-success pull-left mt-2"
                                                        icon="fa fa-floppy-o"
                                                        label="Transmit to McKay"
                                                        pButton
                                                        type="submit"></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </p-fieldset>
                        </div>

                        <div *ngIf="currentEtree.isMbelEligible==true" class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true">
                                <ng-template pTemplate="header">Update bandwidth split</ng-template>
                                <div class=" col-12">
                                    <p *ngIf="bandwidthHeader" [innerHTML]="bandwidthHeader"></p>
                                </div>
                                <div class=" col-12">
                                    <form [formGroup]="bandwidthForm">
                                        <div class="p-grid p-fluid">
                                            <div [ngClass]="{'has-error': showBandwidthFormErrorMessage('lcmBandwidth')}"
                                                 class="form-group col-12 display-flex">
                                                <label class="col-form-label" for="lcmBandwidth">
                                                    LCM bandwidth allocation (Mbps) :
                                                </label>
                                                <div class="pull-left col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false" [min]="0"
                                                               [size]="2"
                                                               [step]="0.5"
                                                               formControlName="lcmBandwidth" id="lcmBandwidth">
                                                    </p-spinner>
                                                </div>
                                            </div>
                                            <div [ngClass]="{'has-error': showBandwidthFormErrorMessage('mbelBandwidth')}"
                                                 class="form-group col-12 display-flex">
                                                <label class="col-form-label" for="mbelBandwidth">
                                                    MBEL bandwidth allocation (Mbps) :
                                                </label>
                                                <div class="pull-left col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false"
                                                               [min]="0"
                                                               [size]="2"
                                                               [step]="0.5"
                                                               formControlName="mbelBandwidth"
                                                               id="mbelBandwidth">
                                                    </p-spinner>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <button (click)="saveBandwidth()" [disabled]="!bandwidthForm.valid"
                                                        class="p-button-success pull-left"
                                                        icon="fa fa-floppy-o"
                                                        label="Transmit to McKay"
                                                        pButton
                                                        type="submit"></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </p-fieldset>
                        </div>

                        <div *ngIf="currentEtree.spsEligible==true" class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true">
                                <ng-template pTemplate="header">Update SPS MAC list (LCM to LCM)</ng-template>
                                <p><a (click)="downloadSpsMAcListAsSamleCsv()" [routerLink]="" class="p-button-link">Download
                                    sample file</a></p>
                                <div *ngIf="uploadOfMacAddresses" class="col-12 alert alert-secondary"
                                     style="background-color: #6f96d069;">Thanks for the upload. It will be validated
                                    and the new configuration
                                    will be uploaded to the switch during the next maintenance window. Once the switch
                                    configuration has
                                    been updated the details will be available in the E-Tree’s SPS & MAC address list.
                                </div>
                                <div class=" col-12" *ngIf="malformatedFile===true">
                                    <p class="alert alert-danger" *ngIf="malformatedFile===true">
                                        Unable to parse input file
                                    </p>
                                </div>
                                <div *ngIf="macAddressArray.length > 0" class=" col-12">
                                    <p *ngIf="showSpscMacWarning" style="color: #cb2d3e">
                                        File content invalid: the file must have 16 or less mac couples with one line
                                        for headers
                                    </p>
                                    <p class="d-inline" [innerHTML]="macAddressHeader">
                                    </p>&nbsp;
                                    <p class="d-inline mb-1">
                                <span
                                        *ngIf="csvDatabaseFileToDwonloadBlob && uploadedMacAddressArray.length ===0">
                                <a (click)="downloadMAcListAsCsv()" [routerLink]="">(Download) </a>
                                </span>
                                    </p>
                                    <br/>
                                    <br/>
                                    <p-table [value]="macAddressArray">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>#</th>
                                                <th>source</th>
                                                <th>destination</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template let-row let-rowIndex="rowIndex" pTemplate="body">
                                            <tr>
                                                <td>{{ rowIndex + 1 }}</td>
                                                <td>{{ row[0] }}</td>
                                                <td>{{ row[1] }}</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <div>
                                    <form [formGroup]="macUploadForm" style="width: 100%;max-width: inherit;">
                                        <div class="p-grid p-fluid">
                                            <div [ngClass]="{'has-error': showMacUploadFormErrorMessage('macAdresseFile')}"
                                                 class="form-group col-lg-12 upload-container">
                                                <label class="col-form-label" for="clientReference">
                                                    MAC file UPLOAD:
                                                </label>
                                                <div class="pull-left col-form-input p-inputgroup">
                                                    <p-fileUpload (onClear)="clearMacFileUpload()"
                                                                  (onRemove)="clearMacFileUpload()"
                                                                  (uploadHandler)="uploadMacFile($event)"
                                                                  accept=".csv"
                                                                  class="fieldset-container"
                                                                  customUpload="true"
                                                                  id="macAdresseFile"
                                                                  name="macAdresseFile"
                                                                  showCancelButton="false">

                                                    </p-fileUpload>
                                                </div>
                                                <div class="form-group">
                                                    <button (click)="transmitMacFile()"
                                                            [disabled]="uploadedMacAddressHeader.length === 0 || showSpscMacWarning===true"
                                                            class="p-button-success pull-left"
                                                            icon="fa fa-floppy-o"
                                                            label="Transmit to Mckay"
                                                            pButton
                                                            type="submit">

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </p-fieldset>
                        </div>
                        <div *ngIf="currentEtree.isMbelEligible==true" class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true">
                                <ng-template pTemplate="header">Update SPS MAC list (MBEL to LCM)</ng-template>
                                <p><a (click)="downloadMbelMAcListAsSamleCsv()" [routerLink]="" class="p-button-link">Download
                                    sample file</a></p>
                                <div *ngIf="uploadOfMbelMacAddresses" class="col-12 alert alert-secondary"
                                     style="background-color: #6f96d069;">Thanks for the upload. It will be validated
                                    and the new
                                    configuration
                                    will be uploaded to the switch during the next maintenance window. Once the switch
                                    configuration has
                                    been updated the details will be available in the E-Tree’s SPS & MAC address list.
                                </div>
                                <div class=" col-12" *ngIf="malformatedFileSps===true">
                                    <p class="alert alert-danger" *ngIf="malformatedFileSps===true">
                                        Unable to parse input file
                                    </p>
                                </div>
                                <div *ngIf="mbelMacAddressArray.length > 0" class=" col-12">
                                    <p *ngIf="showMbelMacWarning" style="color: #cb2d3e">
                                        File content invalid: the file must have exactly 1 mac couple with one line for
                                        headers
                                    </p>

                                    <p [innerHTML]="mbelMacAddressHeader" class="d-inline">
                                    </p>&nbsp;
                                    <p class="d-inline mb-1">
                                <span
                                        *ngIf="csvMbelDatabaseFileToDwonloadBlob && uploadedMbelMacAddressArray.length ===0">
                                <a (click)="downloadMbelMAcListAsCsv()" [routerLink]="">(Download) </a>
                                </span>
                                    </p>
                                    <br/>
                                    <br/>
                                    <p-table [value]="mbelMacAddressArray">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>#</th>
                                                <th>source</th>
                                                <th>destination</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template let-row let-rowIndex="rowIndex" pTemplate="body">
                                            <tr>
                                                <td>{{ rowIndex + 1 }}</td>
                                                <td>{{ row[0] }}</td>
                                                <td>{{ row[1] }}</td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                                <div class=" col-12">
                                    <form [formGroup]="mbelMacUploadForm" style="width: 100%;max-width: inherit;">
                                        <div class="p-grid p-fluid">
                                            <div [ngClass]="{'has-error': showMacUploadFormErrorMessage('macAdresseFile')}"
                                                 class="form-group col-12 upload-container">
                                                <label class="col-form-label" for="clientReference">
                                                    MAC file UPLOAD:
                                                </label>
                                                <div class="pull-left col-form-input p-inputgroup">
                                                    <p-fileUpload (onClear)="clearMbelMacFileUpload()"
                                                                  (onRemove)="clearMbelMacFileUpload()"
                                                                  (uploadHandler)="uploadMbelMacFile($event)"
                                                                  accept=".csv"
                                                                  class="fieldset-container"
                                                                  customUpload="true"
                                                                  id="mbelMacAdresseFile"
                                                                  name="mbelMacAdresseFile"
                                                                  showCancelButton="false">

                                                    </p-fileUpload>
                                                </div>
                                                <div class="form-group">
                                                    <button (click)="transmitMbelMacFile()"
                                                            [disabled]="uploadedMbelMacAddressHeader.length === 0 || showMbelMacWarning===true"
                                                            class="p-button-success pull-left"
                                                            icon="fa fa-floppy-o"
                                                            label="Transmit to Mckay"
                                                            pButton
                                                            type="submit">

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </p-fieldset>
                        </div>
                        <div *ngIf="currentEtree.spsEligible" class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true">
                                <ng-template pTemplate="header">Update SPS buffer priorities (LCM injection)
                                </ng-template>
                                <div *ngIf="uploadOfBufferPriorities" class="col-12 alert alert-secondary"
                                     style="background-color: #6f96d069;">Thanks for the upload. It will be validated
                                    and the new
                                    configuration
                                    will be uploaded to the switch during the next maintenance window. Once the switch
                                    configuration has
                                    been updated the details will be available in the E-Tree’s SPS & MAC address list.
                                </div>
                                <div [innerHTML]="bufferDataHeader" class=" col-12">
                                </div>
                                <div class=" col-12">
                                    <form [formGroup]="bufferPriorityForm">
                                        <div class="p-grid p-fluid">
                                            <div *ngIf="currentEtree.spsEligible==true"
                                                 [ngClass]="{'has-error': showBufferPrioritiesErrorMessage('highPriority')}"
                                                 class="form-group col-12">
                                                <label class="col-form-label" for="highPriority">
                                                    High priority :
                                                </label>
                                                <div class="pull-left col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false" [min]="0"
                                                               [size]="2" formControlName="highPriority"
                                                               id="highPriority">
                                                    </p-spinner>
                                                </div>
                                                <div>(Select number of packets)</div>
                                            </div>

                                            <div [ngClass]="{'has-error': showBufferPrioritiesErrorMessage('lowPriority')}"
                                                 class="form-group col-12 display-flex">
                                                <label class="col-form-label" for="lowPriority">
                                                    Low priority :
                                                </label>
                                                <div class="col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false" [min]="0" [size]="2"
                                                               formControlName="lowPriority"
                                                               id="lowPriority">
                                                    </p-spinner>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <button (click)="saveBufferPriorities()"
                                                        [disabled]="!bufferPriorityForm.valid"
                                                        class="p-button-success pull-right mt-1"
                                                        icon="fa fa-floppy-o"
                                                        label="Transmit to McKay"
                                                        pButton
                                                        type="submit"></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </p-fieldset>
                        </div>
                        <div *ngIf="currentEtree.methodFFPrimeBw==true" class="col-12 p-fluid">
                            <p-fieldset [collapsed]="true" [toggleable]="true">
                                <ng-template pTemplate="header">Update Nx Link Share parameters</ng-template>
                                <div class=" col-12">
                                    <p *ngIf="nxLinkshareHeader" [innerHTML]="nxLinkshareHeader"></p>
                                </div>
                                <div class=" col-12">
                                    <form [formGroup]="nxLinkshareForm">
                                        <div class="p-grid p-fluid">
                                            <div [ngClass]="{'has-error': showNxLinkShareFormErrorMessage('nxls')}"
                                                 class="form-group col-12">
                                                <label class="col-12 col-md-6 col-lg-3 col-form-label" for="nxls">
                                                    NXLS :
                                                </label>
                                                <div class="col-12 col-md-6 col-lg-9 pull-left col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false" [min]="0"
                                                               [size]="2" formControlName="nxls" id="nxls">
                                                    </p-spinner>
                                                </div>
                                            </div>
                                            <div [ngClass]="{'has-error': showNxLinkShareFormErrorMessage('neomb')}"
                                                 class="form-group col-12">
                                                <label class="col-12 col-md-6 col-lg-3 col-form-label" for="neomb">
                                                    NEOMB :
                                                </label>
                                                <div class="col-12 col-md-6 col-lg-2 pull-left col-form-input p-inputgroup">
                                                    <p-spinner [formatInput]="false" [min]="0" [size]="2"
                                                               formControlName="neomb"
                                                               id="neomb">
                                                    </p-spinner>
                                                </div>
                                                <div class="form-group col-12 col-md-6  col-lg-6">
                                                    <button (click)="saveNxLinkShare()"
                                                            [disabled]="!nxLinkshareForm.valid"
                                                            class="p-button-success pull-left"
                                                            icon="fa fa-floppy-o"
                                                            label="Transmit to McKay"
                                                            pButton
                                                            type="submit"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </p-fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog [(visible)]="isJirapopUp"
          [baseZIndex]="10000"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'auto','max-width': '80vw',
                           'max-height': '80vh','min-height':'300px'}"
          [draggable]="false"
          [maximizable]="true"
          [modal]="true"
          [resizable]="true">

    <ng-template pTemplate="header">
        <div class="row">
            <div class="col-md-2">
                <img alt="" class="jira-logo" src="../../../assets/images/logo-jira.png">
            </div>
            <div class="col-md-10 jira-header">
                Create a new Jira issue
            </div>
        </div>
    </ng-template>
    <div class="jira-body">
        <div class="modal-body">
            <p *ngIf="isSendToJiraDisabled"><label class="required-items-alert"> Please fill in all required
                fields</label>
            </p>
            <label *ngIf="loggedInUser" class="custom-label mt-2  mb-2"> Reporter: {{ loggedInUser.username }}</label>
            <label *ngIf="currentEtree" class="custom-label mt-2 mb-2"> Etree: {{ currentEtree.name }}</label>
            <label class="jira-text">POPs:</label>
            <p-multiSelect (onChange)="onSelectPop()" [(ngModel)]="selectedPopsForJira" placeholder="Select Pop"
                           [filter]="true"
                           [options]="popsItemForJira"
                           [panelStyle]="{'width':'95em'}"
                           [style]="{'width':'95em'}" class="p-multiSelect" required></p-multiSelect>
            <ng-container *ngIf="selectedPopsForJira">
                <div *ngFor="let pop of selectedPopsForJira ;let i = index" class="pop-item">
                    <div class="pop-info">
                        <label class="jira-text">{{ pop }}</label>
                        <span title="Check this box only if you know that there is a physical issue on the cross-connect "> Is there any issue impacting a cross connect?</span>
                    </div>
                    <p-inputSwitch (onChange)="onPopSwitchChange(i, $event)" class="pop-switch"></p-inputSwitch>
                </div>
            </ng-container>
            <div *ngIf="displayXcoDropDown">
                <label class="jira-text">Cross Connects:</label>
                <p-multiSelect (onChange)="setIsSendTojiraflag()" [(ngModel)]="selectedXcoForJira"
                               placeholder="Select Cross Connect"
                               [filter]="true" [options]="crossConnectItemForJira"
                               [panelStyle]="{'width':'95em'}"
                               [style]="{'width':'95em'}" class="p-multiSelect" required></p-multiSelect>
            </div>
            <label class="custom-label mt-2 " for="description">Description:</label>
            <p-editor (onTextChange)="setIsSendTojiraflag()" [(ngModel)]="jiraCustomDescription"
                      [style]="{ height: '80px' }"
                      id="description" name="description" placeholder="Enter the description"></p-editor>
            <label class="jira-text mt-2" for="priority">Priority:</label>
            <select [(ngModel)]="selectedPriority" class="p-dropdown with-icons" id="priority" name="priority">
                <option data-icon="fas fa-life-ring" value="support">Support</option>
                <option data-icon="fas fa-exclamation-triangle" value="urgent">Urgent</option>
            </select>
            <div *roles="['ROLE_CLIENT']" class="mt-2">
                <label class="jira-text">Request participant:</label>
                <p-multiSelect
                        [(ngModel)]="selectedParticipantForJira"
                        [filter]="true"
                        [options]="participantsItemForJira"
                        [panelStyle]="{'width':'95em'}"
                        [placeholder]="'Select Participants'"
                        [style]="{'width':'95em'}"
                        class="p-multiSelect"
                        required>
                </p-multiSelect>
            </div>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center; margin-top: 1rem;">
            <button (click)="createIssue()" [disabled]=disableCreateIssueButton() class="create-button" appNoDblClick>Send to
                JIRA
            </button>
            <button (click)="cancel()" class="cancel-button">Cancel</button>
        </div>
    </div>
</p-dialog>
